(function () {
  var DISCOUNT = 5;

  function parseMoney(text) {
    if (!text) return null;
    var cleaned = text.replace(/,/g, '');
    var match = cleaned.match(/[\d]+\.?\d*/);
    return match ? parseFloat(match[0]) : null;
  }

  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function findCurrentPrice(memberEl) {
    var scope = memberEl.closest('.product, .product-info, [id^="MainProduct"], [id^="ProductInfo"]') || document;
    var selectors = [
      '.price__container .price-item--regular',
      '.price__regular .price-item',
      '.price-item--regular:not(.price-item--sale)',
      '.price__container .price-item--sale',
      '.price-item--sale',
      '.price-item',
      '.price__current',
      '.product-price',
      '[data-product-price]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = scope.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        var val = parseMoney(els[j].textContent);
        if (val !== null && val > 0) return val;
      }
    }
    return null;
  }

  function updateAll() {
    var widgets = document.querySelectorAll('.member-price');
    if (!widgets.length) return;
    widgets.forEach(function (widget) {
      var valueEl = widget.querySelector('.value');
      if (!valueEl) return;
      var price = findCurrentPrice(widget);
      if (price === null) return;
      var corrected = formatMoney(Math.max(price - DISCOUNT, 0));
      if (valueEl.textContent.trim() !== corrected) {
        valueEl.textContent = corrected;
      }
    });
  }

  var scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      updateAll();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.closest('variant-selects') || e.target.closest('.product-form'))) {
      scheduleUpdate();
    }
  });

  var observer = new MutationObserver(function () {
    scheduleUpdate();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  scheduleUpdate();
})();
